export const DETERMINANTS = {
    'Картофель': 'potato',
    'Морковь': 'carrot',
    'Пшеница': 'wheat',
    'Рожь': 'rye',
    'Ячмень': 'barley'
};